<template>
  <div class="mx-auto w-full max-w-sm lg:w-96">
    <div>
      <img
        class="h-6 w-auto"
        src="/img/traveloffice-logo.svg"
        alt="Workflow"
      >
      <h2 class="mt-4 text-3xl leading-9 font-extrabold text-gray-900">
        Set a new password
      </h2>
    </div>

    <form @submit.prevent="submit">
      <div>
        <jet-label
          for="email"
          value="Email"
        />
        <jet-input
          id="email"
          v-model="form.email"
          type="email"
          class="mt-1 block w-full"
          required
          autofocus
        />
      </div>

      <div class="mt-4">
        <jet-label
          for="password"
          value="Password"
        />
        <jet-input
          id="password"
          v-model="form.password"
          type="password"
          class="mt-1 block w-full"
          required
          autocomplete="new-password"
        />
      </div>

      <div class="mt-4">
        <jet-label
          for="password_confirmation"
          value="Confirm Password"
        />
        <jet-input
          id="password_confirmation"
          v-model="form.password_confirmation"
          type="password"
          class="mt-1 block w-full"
          required
          autocomplete="new-password"
        />
      </div>

      <div class="flex items-center justify-end mt-4">
        <jet-button
          :class="{ 'opacity-25': form.processing }"
          :disabled="form.processing"
        >
          Reset Password
        </jet-button>
      </div>
    </form>
  </div>
</template>

<script>
import JetInput from '../../Jetstream/Input.vue';
import JetLabel from '../../Jetstream/Label.vue';
import JetButton from '../../Jetstream/Button.vue';
import AuthLayout from '../../Layouts/AuthLayout.vue';

export default {
  components: {
    JetButton,
    JetInput,
    JetLabel,
  },
  layout: AuthLayout,

  props: {
    email: String,
    token: String,
  },
  data() {
    return {
      form: this.$inertia.form({
        token: this.token,
        email: this.email,
        password: '',
        password_confirmation: '',
      }),
    };
  },

  methods: {
    submit() {
      this.form.post(this.route('password.update'), {
        onFinish: () => this.form.reset('password', 'password_confirmation'),
      });
    },
  },
};
</script>
